<!-- Main content -->
<div
  id="main-content"
  class="custom-content"
  [class.nomargin]="!showMainMenu"
  [class.ml-0]="!showSidebar || visibleItems <= 1">
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>

<!-- Selecció de client -->
<p-dialog
  *ngIf="hasClients && userCanSeeClientes"
  [header]="clientHeaderDialog"
  [(visible)]="showClientDialog"
  [style]="{width: '40vw' ,height: '60vh'}"
  class="dlg-40x60"
  [breakpoints]="dialogBreakpoints"
  (onShow)="scrollToTop()"
  (onHide)="onDialogHide()"
  (onShowing)="onDialogShow()"
  [closable]="false">

  <label>Seleccionar {{ clienteName }}</label>

  <p-select
    [options]="clientes.filtered"
    [(ngModel)]="clientes.selected"
    [placeholder]="'Seleccionar ' + clienteName"
    optionValue="value"
    optionLabel="label"
    [filter]="true"
    [showClear]="true"
    (onChange)="updateClient()">
  </p-select>

  <div class="dlg-actions">
    <button class="btn btn-primary" (click)="closeClientDialog()">Aceptar</button>
  </div>
</p-dialog>

<!-- Navbar principal -->
@if (showMainMenu) {
  <div class="custom-navbar navbar-container">
    <div class="navbar-row w-100 d-flex justify-content-between align-items-center flex-nowrap px-3">

      <!-- Logo + Client -->
      <div class="d-flex justify-content-evenly align-items-center gap-2">
        <button class="rounded-5 border-0" (click)="router.navigate(['dashboard','inicio'])">
          <span class="logo-container h-full">
            <img [src]="logoUrl" alt="Logo" />
          </span>
        </button>

        <div *ngIf="hasClients && userCanSeeClientes && appName !== 'gruesnadal'"
             class="client-selected"
             [ngStyle]="appName === 'detorres' ? {'margin-left':'-10rem'} : null">
          <button class="btn btn-light client-btn"
                  [disabled]="!dashboardEvent.changeClientActive"
                  (click)="changeClient()">
            <i class="fa fa-user"></i>
            <span *ngIf="clientes.selected">
              {{ (clientes.selected.razon_social || clientes.selected.nombre) + ' ' + (clientes.selected.apellido_1 ? (clientes.selected.apellido_1 + ' ' + clientes.selected.apellido_2) : '' )}}
            </span>
          </button>
        </div>
      </div>

      <!-- Header central -->
      <div class="navbar-col header d-flex justify-content-center">
        <h5>{{ dashboardEvent.headerTitle }}</h5>
      </div>

      <!-- Usuari + menú -->
      <div class="navbar-col user-info d-flex align-items-center justify-content-end">
        <span class="user-name text-white">{{ currentUser.nombre }} {{ currentUser.apellidos }}</span>
        <div class="menu-trigger">
          <p-menu #menu [model]="popupItems" [popup]="true" appendTo="body"></p-menu>
          <p-button [style]="menuBtnStyle" severity="secondary" icon="pi pi-bars" [text]="true"
                    (click)="menu.toggle($event)"></p-button>
        </div>
      </div>
    </div>
  </div>
}

<!-- Mi perfil -->
<p-dialog header="Mi perfil"
          [(visible)]="showClientProfile"
          class="dlg-40x60"
          [breakpoints]="dialogBreakpoints"
          (onShow)="scrollToTop()">

  <div *ngIf="!isComunero" class="w-100">
    <div class="flex-between">
      <p class="font-weight-bold">{{ currentUser.email || 'Usuario sin email' }}</p>
      <div *ngIf="showUsuariosFirma && currentUser.firma">
        <button class="btn btn-link btn-link-tight" (click)="verFirma()">Firma</button>
      </div>
    </div>

    <app-form-builder [model]="currentUser" [undoEnabled]="false" [distributionColumns]="2"
                      [fields]="formFields" (formChanges)="formChanges($event)">
    </app-form-builder>

    <app-form-builder [model]="currentUser" [undoEnabled]="false" [distributionColumns]="2"
                      [fields]="formFields2" (formChanges)="formChanges($event)">
    </app-form-builder>

    <div class="alert alert-light text-secondary p-2 mt-3 small">
      <p *ngIf="appName !== 'viverospereira'">Los cambios tendrán efecto cuando vuelva a iniciar sesión.</p>
      <p *ngIf="appName === 'viverospereira'">8 MB de 1 GB usados.</p>
    </div>

    <div *ngIf="showUsuariosFirma" class="w-100 mb-4 d-flex justify-content-center">
      <div>
        <h6>Firma</h6>
        <div class="canvas-wrap">
          <app-signature #sp (onEndEvent)="drawComplete(signaturePadElement)"></app-signature>
        </div>
        <button data-html2canvas-ignore="true" class="p-0 m-0 btn btn-link btn-link-tight"
                (click)="clearSigPad(signaturePadElement)">Borrar</button>
      </div>
    </div>
  </div>

  <div *ngIf="isComunero" class="dlg-fixed">
    <div class="flex-between">
      <p class="font-weight-bold">{{ currentClient?.email || 'Usuario sin email' }}</p>
    </div>
    <app-form-builder [model]="currentClient" [undoEnabled]="false" [distributionColumns]="2"
                      [fields]="formClient" (formChanges)="formChanges($event)">
    </app-form-builder>
  </div>

  <p-footer>
    <div class="dlg-actions">
      <button class="btn btn-dark mx-2" (click)="closeClientProfile()">Volver</button>
      <button *ngIf="!actualizando" class="btn btn-primary mx-2" (click)="saveProfileEdit()">
        <i class="fa fa-pencil" aria-hidden="true"></i> Actualizar
      </button>
      <button *ngIf="actualizando" class="btn btn-primary mx-2" disabled>
        <div class="spinner-border spinner-border-sm" role="status"></div> Actualizando...
      </button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog header="Publicidad" [(visible)]="showAdvertisingForm" (onShow)="scrollToTop()">
    <div>
        <input type="file" #adjuntarFoto (change)="fileChange($event)" style="display: none;" accept="image/*" />
        <button *ngIf="anuncioImagen" class="btn btn-link" (click)="verAdjunto()">Ver</button>
        <input type="button" class="btn btn-success" style='border-radius: 5px;
            font-size: 1em;
            padding: 6px 12px;
            font-family: "Roboto", "Trebuchet MS", Arial, Helvetica, sans-serif;' value="Añadir foto"
            (click)="readUrl(adjuntarFoto)" />
    </div>
    <br>
    <br>
    <h3>Descripción</h3>
    <textarea rows="5" cols="30" pTextarea [(ngModel)]="anuncioTexto"></textarea>
    <div class="alert alert-light text-secondary p-2 mt-3 small">
        El anunció se le aparecerá a los usuarios al iniciar sesión.
    </div>

    <br>
    <div class="d-flex justify-content-center">
        <button style="margin-right: 1rem" class="btn btn-dark mx-2" (click)="closeAdvertisingForm();">
            Volver
        </button>
        <button class="btn btn-primary mx-2" (click)="postAdvertisement();">
            <i class="fa fa-pencil" aria-hidden="true"></i>
            Publicitar
        </button>
    </div>
</p-dialog>

<p-dialog *ngIf="appName === 'agroleza' && anuncioImagen" header="¡Atención!" [(visible)]="mostrarAnuncioEmergente"
    [modal]="true" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <img [src]="serverUrl + 'imagenes_publicitarias/' + anuncioImagen" class="anuncio" alt="Anuncio">
    <p style="font-size: 30pt; text-align: center" class="m-0">
        {{anuncioTexto}}
    </p>
</p-dialog>

<p-dialog header="Copia de seguridad" [(visible)]="showBackupDialog" (onShow)="scrollToTop()">
    <div style="width: 380px; height: 220px; display: flex; flex-direction: column; align-items: center;">
        <p style="text-align: center;">
            Se descargará una copia de seguridad de todos los datos almacenados en la base de datos.
            <br><br>
            <small *ngIf="this.applicationType !== 'cropgest'"><b>Esta opción sólo está disponible para usuarios
                    administradores.</b></small>
        </p>

        <br>

        <div class="d-flex justify-content-center" style="margin-bottom: 5%;">
            <button style="margin-right: 1rem" class="btn btn-dark mx-2" (click)="closeBackupDialog();">
                Volver
            </button>
            <button class="btn btn-primary mx-2" (click)="downloadBackup()" [disabled]="isDownloadingCsv">
                <i class="fa fa-download" aria-hidden="true"></i>
                {{isDownloadingCsv ? 'Generando csv...' : 'Descargar'}}
            </button>
        </div>
    </div>
</p-dialog>

<p-dialog header="Actividad de los usuarios" [(visible)]="showVademecumDialog" (onShow)="scrollToTop()">
    <div style="width: 80vw !important;">
        <div style="height: 220px; overflow-y: auto; overflow-x: hidden;">
            <table id="table-vademecum" class="table table-hover">
                <thead>
                    <th>Usuario</th>
                    <th>Producto</th>
                    <th>Referencia</th>
                    <th>Fecha</th>
                    <th>Búsqueda</th>
                    <th>Acción</th>
                </thead>
                <tbody>
                    <tr *ngFor="let row of userActivity">
                        <td>{{row?.nombreUsuario}}</td>
                        <td>{{row?.nombreProducto}}</td>
                        <td>{{row?.referencia}}</td>
                        <td>{{row?.fecha}}</td>
                        <td>{{row?.textoBuscar}}</td>
                        <td>{{row?.accion}}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="my-2 d-flex justify-content-center">
            <button class="btn btn-dark mx-2" (click)="showVademecumDialog = false">
                Volver
            </button>
            <button class="btn btn-primary mx-2" (click)="downloadVademecumActivity()" [disabled]="isDownloadingCsv">
                <i class="fa fa-download" aria-hidden="true"></i>
                {{isDownloadingCsv ? 'Generando CSV...' : 'Descargar'}}
            </button>
        </div>
    </div>
</p-dialog>

<p-dialog header="Mi listado de productos" [(visible)]="showVademecumListadoDialog" (onShow)="scrollToTop()">
    <div style="width: 80vw !important;">
        <div style="overflow-y: scroll;">
            <div class="mb-3 d-flex justify-content-between align-items-center">
                <span style="font-size: 1.1rem;">Productos</span>
                <div class="d-flex">
                    <button class="mr-2 btn btn-primary" style="font-size: .7rem; padding: 4px 8px;"
                        (click)="pasteListadoProductos()">
                        Añadir productos copiados
                    </button>
                    <button class="btn btn-success" style="font-size: .7rem; padding: 4px 8px;"
                        (click)="saveListadoProductos()"
                        [disabled]="productosApi.listadoVademecum.PUT.isLoading || productosApi.listadoVademecum.POST.isLoading">
                        {{
                        productosApi.listadoVademecum.PUT.isLoading || productosApi.listadoVademecum.POST.isLoading
                        ? 'Guardando...'
                        : 'Guardar listado'
                        }}
                    </button>
                </div>
            </div>
            <!--<p-chips #pChips [(ngModel)]="listadoProductos.productos" [style]="{'height': '40vh'}">
            </p-chips>-->
        </div>

        <div class="my-2 d-flex justify-content-center">
            <button class="btn btn-dark mx-1" (click)="showVademecumListadoDialog = false">
                Volver
            </button>
            <button class="btn btn-primary mx-1" (click)="printListadoProductos()" [disabled]="isDownloadingCsv">
                <i class="fa fa-download" aria-hidden="true"></i>
                {{
                isDownloadingCsv
                ? isGeneratingCsv
                ? 'Descargando usos... ' + (productosCSV.length || 0) + '/' + (listadoProductos.productos?.length ||
                0)
                : 'Generando csv...'
                : 'Descargar'
                }}
            </button>
        </div>
    </div>
</p-dialog>


<!-- Sidebar -->
<div *ngIf="showSidebar && (visibleItems > 1)" class="custom-sidebar">
  <div class="content">
    <div *ngFor="let item of dashboardEvent.menuItemData; trackBy: trackByMenuId">
      <ng-container *ngIf="item && (item.visible === undefined || item.visible === true)">
        <app-sidenav-cell
          [id]="item.id"
          [text]="item.text"
          [icon]="item.icon"
          [isSelected]="item.isSelected"
          [expand]="item.expandable"
          (cellClickHandler)="onNavItemClick($event)"
          (subcellClickHandler)="onSubNavItemClick($event)">
        </app-sidenav-cell>
      </ng-container>
    </div>
  </div>
</div>

<!-- Toast -->
<p-toast styleClass="custom-toast" [style]="{ zIndex: '1010' }"></p-toast>

<!-- Watermark -->
<div *ngIf="showWatermark" class="wmk">
  <a title="Aplicación creada por Locatec. Todos los derechos reservados."
     target="_blank" href="https://locatec.es/">
    <img [src]="urlLogoLocatec" alt="Locatec.es">
  </a>
</div>

<a id="csvLink" class="visually-hidden"></a>